<script lang="ts" setup>
  import type { PlayerSession } from '../../../../shared/api/player.ts';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import RejoinGameCard from '../RejoinGameCard.vue';
  import SpotifySignInButton from './SpotifySignInButton.vue';

  defineProps<{ session?: PlayerSession }>();
  defineEmits<{ rejoin: []; spotifySignIn: [] }>();
</script>

<template>
  <MobileViewLayout justify="center">
    <RejoinGameCard
      v-if="session"
      :session="session"
      hint="Or sign in with Spotify below to host a new game."
      @rejoin="$emit('rejoin')"
    />
    <template #footer>
      <SpotifySignInButton @click="$emit('spotifySignIn')">Sign in with Spotify</SpotifySignInButton>
    </template>
  </MobileViewLayout>
</template>
